import { RocketIcon } from "@radix-ui/react-icons";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { FormEvent, useState } from "react";

import { Button } from "@/components/ui/button";
import {
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Icons } from "@/components/icons";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useUpdateAccount } from "@/clients/deflow";

export const Route = createFileRoute("/plugin/figma/onboarding/1")({
  component: OnboardingStep1,
});

interface CustomElements extends HTMLFormControlsCollection {
  firstName: HTMLInputElement;
  lastName: HTMLInputElement;
}

interface CustomForm extends HTMLFormElement {
  readonly elements: CustomElements;
}

function OnboardingStep1() {
  const navigate = useNavigate();
  const [firstNameValid, setFirstNameValid] = useState(false);
  const [lastNameValid, setLastNameValid] = useState(false);
  const [isLoading] = useState(false);

  const { trigger, isMutating } = useUpdateAccount();

  const onSubmit = async (event: FormEvent<CustomForm>) => {
    event.preventDefault();

    await trigger({
      firstName: event.currentTarget.elements.firstName.value,
      lastName: event.currentTarget.elements.lastName.value,
    });
    navigate({ to: "/plugin/figma/onboarding/2", replace: true });
  };

  return (
    <div>
      <div className="px-8 pt-8">
        <div className="w-full">
          <form onSubmit={onSubmit}>
            <CardHeader>
              <CardTitle className="flex">
                {`Let's get started`} <RocketIcon className="ml-2" />
              </CardTitle>
              <CardDescription>
                Tell us a bit about yourself. What should we call you?
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid w-full items-center gap-4">
                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="name">First name</Label>
                  <Input
                    id="firstName"
                    placeholder="Your first name"
                    onChange={(event) => {
                      setFirstNameValid(event.target.value.length > 3);
                    }}
                  />
                </div>
                <div className="flex flex-col space-y-1.5">
                  <Label htmlFor="name">Last name</Label>
                  <Input
                    id="lastName"
                    placeholder="Your last name"
                    onChange={(event) => {
                      setLastNameValid(event.target.value.length > 3);
                    }}
                  />
                </div>
              </div>
            </CardContent>
            <CardFooter className="flex">
              <Button
                className="ml-auto"
                disabled={
                  !firstNameValid || !lastNameValid || isLoading || isMutating
                }
              >
                {isLoading && (
                  <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                )}
                Continue
              </Button>
            </CardFooter>
          </form>
        </div>
      </div>
    </div>
  );
}
